<template>
	<div class="my-3">
		<CRow>
			<CCol>
				<h3 class="typo-h5">
					Reward limit per order
				</h3>
			</CCol>
		</CRow>
		<CRow>
			<CCol md="8">
				<label>
					Apply freebie for every XXX purchase amount/quantity
				</label>
			</CCol>
			<CCol md="4">
				<div class="d-flex flex-row justify-content-end freebie-apply">
					<CSwitch
						:checked.sync="formData.freebieLimit.isApplyFreebieLimitPerOrder"
						variant="3d"
						size="sm"
						class="switch-custom"
						color="success"
						@update:checked="handleUpdateIsApplyFreebieLimitPerOrder"
					/>
					<span>{{ formData.freebieLimit.isApplyFreebieLimitPerOrder ? 'On' : 'Off' }}</span>
				</div>
			</CCol>
		</CRow>
		<CRow v-if="formData.freebieLimit.isApplyFreebieLimitPerOrder">
			<CCol md="4">
				<BaseDropDown
					v-model="selectedLimitType"
					:searchable="false"
					:options="DAPP_REWARD_FREEBIE_CONDITION_EVERY_OPTION"
					:allow-empty="false"
					class="mb-1"
					track-by="value"
					label="name"
					label-drop-down="Every (X)"
					@input="handleSelectLimitType"
				/>
			</CCol>
			<CCol
				md="4"
			>
				<BaseInputNumber
					:key="isPrice ? 'conditionPrice' : 'conditionQuantity'"
					v-model="rewardLimitValue"
					:decimal-scale="isPrice ? 2 : 0"
					:invalid-feedback="inputErrors($v.formData.freebieLimit.rewardLimit)"
					:is-valid="!$v.formData.freebieLimit.rewardLimit.$error"
					allow-null-value
					:label="isPrice ? 'Purchase amount (X)*' : 'Quantity (X)*'"
					:append-text="isPrice ? '฿' : 'Qty.'"
					:placeholder="getPlaceholder"
					text-align="left"
				/>
			</CCol>
			<!-- Limit col -->
			<CCol md="4">
				<BaseInputNumber
					v-model="itemLimitValue"
					allow-null-value
					label="Free item (Y) limit per order"
					append-text="Qty."
					text-align="left"
					placeholder="Quantity"
				/>
			</CCol>

			<!-- Dummy col -->
			<CCol md="4" />
			<CCol md="4">
				<label class="label">Default value is main product price</label>
			</CCol>
			<CCol md="4">
				<label class="label">Default value is unlimit</label>
			</CCol>
		</CRow>
		<CRow v-else>
			<CCol>
				<label>
					Apply freebie without purchase limit
				</label>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';

import {
	DAPP_REWARD_FREEBIE_CONDITION_EVERY_OPTION,
	DAPP_REWARD_FREEBIE_CONDITION_EVERY,
	DAPP_REWARD_FREEBIE_CONDITION_EVERY_LABELS,
} from '../enums/promotions';

export default {
	props: {
		formData: {
			type: Object,
			default: () => {},
		},
	},
	validations() {
		return {
			formData: {
				freebieLimit: {
					rewardLimit: {
						required: requiredIf((value) => value.isApplyFreebieLimitPerOrder),
						greaterThanZero: (value, vm) => {
							if (!vm.isApplyFreebieLimitPerOrder) {
								return true;
							}

							return value > 0;
						},
					},
				},
			},
		};
	},
	data() {
		return {
			DAPP_REWARD_FREEBIE_CONDITION_EVERY_OPTION,
		};
	},
	computed: {
		selectedLimitType: {
			get() {
				return this.DAPP_REWARD_FREEBIE_CONDITION_EVERY_OPTION
					.find((option) => option.value === this.formData.freebieLimit.limitType);
			},
			set(option) {
				this.$set(this.formData.freebieLimit, 'limitType', option ? option.value : '');
			},
		},
		rewardLimitValue: {
			get() {
				return this.formData.freebieLimit.rewardLimit;
			},
			set(value) {
				this.$set(this.formData.freebieLimit, 'rewardLimit', value);
			},
		},
		itemLimitValue: {
			get() {
				return this.formData.freebieLimit.itemLimit;
			},
			set(value) {
				this.$set(this.formData.freebieLimit, 'itemLimit', value);
			},
		},
		isPrice() {
			return this.formData.freebieLimit.limitType === DAPP_REWARD_FREEBIE_CONDITION_EVERY.PRICE;
		},
		getPlaceholder() {
			return this.isPrice
				? DAPP_REWARD_FREEBIE_CONDITION_EVERY_LABELS[DAPP_REWARD_FREEBIE_CONDITION_EVERY.PRICE]
				: DAPP_REWARD_FREEBIE_CONDITION_EVERY_LABELS[DAPP_REWARD_FREEBIE_CONDITION_EVERY.QUANTITY];
		},
	},
	created() {
		if (!this.formData.freebieLimit) {
			this.$set(this.formData, 'freebieLimit', {});
		}
		if (this.formData.freebieLimit.isApplyFreebieLimitPerOrder === undefined) {
			this.$set(this.formData.freebieLimit, 'isApplyFreebieLimitPerOrder', true);
		}
		if (this.formData.freebieLimit.limitType === undefined) {
			this.$set(this.formData.freebieLimit, 'limitType', DAPP_REWARD_FREEBIE_CONDITION_EVERY.QUANTITY);
		}
		if (this.formData.freebieLimit.rewardLimit === undefined) {
			this.$set(this.formData.freebieLimit, 'rewardLimit', null);
		}
		if (this.formData.freebieLimit.itemLimit === undefined) {
			this.$set(this.formData.freebieLimit, 'itemLimit', null);
		}
	},
	methods: {
		handleSelectLimitType() {
			this.formData.freebieLimit.rewardLimit = null;
		},
		inputErrors(validation) {
			if (!validation.required) {
				return this.$t('global.error.required');
			}

			if (!validation.greaterThanZero) {
				return this.$t('global.error.moreThan', { number: '0' });
			}

			return null;
		},
		handleUpdateIsApplyFreebieLimitPerOrder(value) {
			if (value) {
				return;
			}

			this.rewardLimitValue = null;
			this.itemLimitValue = null;
		},
	},
};
</script>

<style lang="scss" scoped>
.freebie-apply {
	gap: 8px;
}

.label {
	@include typo-caption;

	font-weight: $font-weight-bold;
	color: $color-gray-700;
	display: flex;
}
</style>